module.exports = __webpack_public_path__ + "img/30.3d0e21b0.jpg";